module.exports = ":host::ng-deep ng-multiselect-dropdown .multiselect-dropdown > .dropdown-btn{\r\n    border: 1px solid #a94442 !important;\r\n}"